import { createAxiosSdkInstance } from './http';
import { API_REST_URL } from './config';
import { initialize } from './generated';
import type { SDK } from './types';

export const sdkAxios = createAxiosSdkInstance(API_REST_URL, true);

const sdk: SDK = initialize(sdkAxios);

export default sdk;
